var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"featureArea"},[_c('TopFacilityContentsSection',{attrs:{"headline":"施設の特徴から探す","lead":"ご予算や入居条件など、施設の特徴からお探しいただけます。","ulClass":"accordionList","contents-list-items":_vm.contentsItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }